import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";

const extraProps = {
  "data-aos": "zoom-in",
};

function RizeAd({ showcaseRef }) {
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ maxWidth: "768px" });

  const handleLogoClick = () => {
    navigate("/rize/personal");
    if (showcaseRef) {
      showcaseRef?.current?.scrollIntoView();
    }
  };

  return (
    <div className="section rize-ad d-flex flex-row align-items-center">
      <div className="container">
        <div className="d-flex flex-column align-items-center">
          <img
            alt="rize_teaser"
            src={`https://www.alrajhibank.com.my/assets/images/background/teaser_rize_new.svg`}
            className="rize-teaser-image"
            style={{ width: "24vh" }}
            {...(isMobile && extraProps)}
            onClick={handleLogoClick}
          />
        </div>
      </div>
    </div>
  );
}

export default RizeAd;
